import cs from '../locales/cs.json';
import en from '../locales/en.json';
import { getFromLocalStorage } from './LocalStorageUtils';

type Locale = 'cs' | 'en';

const getLocale = (): Locale => {
    const storedLocale = typeof window !== 'undefined'
        ? getFromLocalStorage('inels-locale')
        : null;
    return storedLocale?.toLowerCase().startsWith('cs') ? 'cs' : 'en';
};

const actuatorKeyTranslations: Record<Locale, Record<string, string>> = {
    cs: cs.actuatorKeys,
    en: en.actuatorKeys
};

export const GetNameWithTranslation = (prefix: string, key: string, suffix?: string, type?: 'din' | 'box'): string => {
    const locale = getLocale();
    const translated = actuatorKeyTranslations[locale][key] ?? actuatorKeyTranslations.en[key] ?? key;

    return `${prefix} ${translated}${suffix ?? ''} ${type ? `(${type.toUpperCase()})` : ''}`;
};

const otherDeviceKeyTranslations: Record<Locale, Record<string, string>> = {
    cs: cs.otherDeviceKeys,
    en: en.otherDeviceKeys
};

export const GetOtherDeviceNameWithTranslation = (prefix: string, key: string, suffix?: string): string => {
    const locale = getLocale();
    const translated = otherDeviceKeyTranslations[locale][key] ?? otherDeviceKeyTranslations.en[key] ?? key;

    return `${prefix} ${translated}${suffix ?? ''}`;
};

const detectorKeyTranslations: Record<Locale, Record<string, string>> = {
    cs: cs.detectorKeys,
    en: en.detectorKeys
};

export const GetDetectorNameWithTranslation = (prefix: string, key: string, suffix?: string): string => {
    const locale = getLocale();
    const translated = detectorKeyTranslations[locale][key] ?? detectorKeyTranslations.en[key] ?? key;

    return `${prefix} ${translated}${suffix ?? ''}`;
};